import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import { environment } from '~environments/environment.development';
import { sentryError } from '~utils/sentry-error';

const { sentryEnvironment, logSentryErrors } = environment;

Sentry.init({
  dsn: 'https://41a76e887a12ee8c24358faa65d23c17@o1297331.ingest.us.sentry.io/4510941126197248',
  environment: sentryEnvironment,
  sendDefaultPii: true,
  // tracesSampleRate: 0.05,

  // Filter environmental / library noise that is not actionable app bugs:
  // - zone.js webview/bfcache animation frame state machine errors
  // - Google Maps internal 'refresh' property access in restricted webviews
  ignoreErrors: [
    /requestAnimationFrame.*can not transition to 'running'/,
    /macroTask 'requestAnimationFrame'.*was 'unknown'/,
    /Cannot read properties of undefined \(reading 'refresh'\)/,
  ],

  beforeSend: (event) => (logSentryErrors ? event : null),
});

bootstrapApplication(AppComponent, appConfig).catch((err) => sentryError(err, 'Bootstrap Application Error'));
